(() => {
    HuiNavSectionController.$inject = ['$scope'];

    function HuiNavSectionController($scope) {
        const self = this;
    }

    angular
        .module("harriApp")
        .directive("huiNavSection", function () {
            return {
                restrict: 'E',
                replace: true,
                scope: true,
                bindToController: {
                    label: '<',
                    classNames: '<',
                    showLine: '<',
                },
                transclude: true,
                controllerAs: '$ctrl',
                controller: HuiNavSectionController,
                templateUrl: `../hmodules/harri-main/ui-components/hui-nav-section.html`
            }
        });
})();